export const GET_BEVERAGE_REQUEST = "GET_BEVERAGE_REQUEST";
export const GET_BEVERAGE_SUCCESS = "GET_BEVERAGE_SUCCESS";
export const GET_BEVERAGE_ERROR = "GET_BEVERAGE_ERROR";
